'use client';

import React, { useState } from 'react';
import AuthBrandPanel from './AuthBrandPanel';
import AuthFormPanel from './AuthFormPanel';

export default function AuthPage() {
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');

  return (
    <div className="min-h-screen flex bg-[hsl(220,50%,3%)]">
      <AuthBrandPanel />
      <AuthFormPanel mode={mode} onModeChange={setMode} />
    </div>
  );
}